import {
  ApplicationStatusApi,
  CaseAgentNumberApi,
  CaseNameApi,
  GrandfatheringDataApi,
  SicCodeApi,
  LifeApi,
} from 'BOSTools/api/api';
import {CaseAgentNumber} from 'BOSTools/models/CaseAgentNumber';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';

const applicationStatusApi = new ApplicationStatusApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const caseAgentNumberApi = new CaseAgentNumberApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const sicCodeApi = new SicCodeApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const grandfatheringDataApi = new GrandfatheringDataApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const caseNameApi = new CaseNameApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const lifeApi = new LifeApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  getApplicationStatusBySceneID: async (sceneID: string) => {
    const response = await applicationStatusApi.getApplicationStatusBySceneID(sceneID, '1', getAxiosConfig());

    return handleResponse(response);
  },
  updateApplicationStatus: async (sceneID: string, status: number) => {
    const response = await applicationStatusApi.updateApplicationStatus(sceneID, '1', status, getAxiosConfig());

    return handleResponse(response);
  },
  getCaseAgentNumbersByCaseNumber: async (caseNumber: string) => {
    const response = await caseAgentNumberApi.getCaseAgentNumbersByCaseNumber('1', caseNumber, getAxiosConfig());

    return handleResponse(response);
  },
  updateCaseAgentNumber: async (caseAgentNumber: CaseAgentNumber) => {
    const response = await caseAgentNumberApi.updateCaseAgentNumber(
      caseAgentNumber.caseID!,
      '1',
      caseAgentNumber,
      getAxiosConfig()
    );

    return handleResponse(response);
  },
  getSicCodesByCaseNumber: async (caseNumber: string) => {
    const response = await sicCodeApi.getSicCodesByCaseNumber('1', caseNumber, getAxiosConfig());

    return handleResponse(response);
  },
  updateSicCode: async (groupID: string, sicCode: string) => {
    const response = await sicCodeApi.updateSicCode(groupID, '1', sicCode, getAxiosConfig());

    return handleResponse(response);
  },
  getGrandfatheringData: () =>
    withCancellation(cancelToken =>
      grandfatheringDataApi.getGrandfatheringData('1', getAxiosConfig(cancelToken)).then(handleResponse)
    ),
  getCaseNamesByCaseNumber: async (caseNumber: string) => {
    const response = await caseNameApi.getCaseNamesByCaseNumber('1', caseNumber, getAxiosConfig());

    return handleResponse(response);
  },
  updateCaseName: async (groupID: string, caseName: string) => {
    const response = await caseNameApi.updateCaseName(groupID, '1', caseName, getAxiosConfig());

    return handleResponse(response);
  },

  getLifeDetailsByAccountNumber: async (accountNumber: string) => {
    const response = await lifeApi.getLifeDetailsByAccountNumber('1', accountNumber, getAxiosConfig());

    return handleResponse(response);
  },
  updateWrittenToL70Flag: async (employerID: number, writtenToL70: boolean) => {
    const response = await lifeApi.updateWrittenToL70Flag(employerID, '1', writtenToL70, getAxiosConfig());

    return handleResponse(response);
  },
};
